import { MainHeader, SearchBar } from "@/components";
import StatisticsData from "@/components/StatisticsData/StatisticsData";
import CustomerQuotes from "@/components/Quotes/CustomerQuotesList/CustomerQuotes";

export default function CustomerQuotePage() {
  return (
    <>
      <MainHeader pageName={"Quotes"}>
        <SearchBar />
      </MainHeader>
      <StatisticsData />

      <div className="px-5 mt-5 flex gap-4 relative mb-5">
        <CustomerQuotes />
      </div>
    </>
  );
}
